var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('iframe',{attrs:{"src":"https://docs.google.com/forms/d/e/1FAIpQLScWvSYwgmrUx-UXunpqFXi4XCGc-kai1NjEhxIz-MJqFSX6Hg/viewform?embedded=true","width":"640","height":"864","frameborder":"0","marginheight":"0","marginwidth":"0"}},[_vm._v("Cargando…")])])
}]

export { render, staticRenderFns }